import { createContext } from "react";
import usePractitionerSubscriptionContext from "lib/hooks/usePractitionerSubscriptionContext";

const CheckoutContext = createContext<CheckoutState>(null);

const CheckoutProvider = ({ children }: ComponentProps) => {
  return (
    <CheckoutContext.Provider value={usePractitionerSubscriptionContext()}>
      {children}
    </CheckoutContext.Provider>
  );
};

export { CheckoutContext, CheckoutProvider };
